module.exports = __webpack_public_path__ + "static/img/service-icon.be5eba49.png";